import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { Video } from '@models/video';
import { getVideosByTagId } from '@services/videoPublicService';
import { PagedResult } from '@models/pagination';

export const defaultVideoKey = 'video';

export const videoKeys = {
    tag: (tags: number[], page: number) => [defaultVideoKey, tags, page],
};

export function useVideosByTags(tags: number[], page: number): UseQueryResult<PagedResult<Video>> {
    return useQuery({
        queryKey: videoKeys.tag(tags, page),
        queryFn: () => getVideosByTagId(tags, page),
        enabled: tags.length > 0,
    });
}
